import t from "../localization/t.js";

export function dictionaryFromCoordinateArray(coordinate) {
    return { latitude: coordinate[1], longitude: coordinate[0] };
}

export function arrayFromCoordinateDirctionary(coordinate) {
    return [coordinate.longitude, coordinate.latitude];
}

export function compassDirectionDisplayName(direction) {
    switch (direction) {
        case "NNE":
        case "NE":
            return t("compass.north_east");

        case "ENE":
        case "ESE":
        case "E":
            return t("compass.east");

        case "SE":
            return t("compass.south_east");

        case "SSE":
        case "SSW":
        case "S":
            return t("compass.south");

        case "SW":
            return t("compass.south_west");

        case "WSW":
        case "W":
        case "WNW":
            return t("compass.west");

        case "NW":
            return t("compass.north_west");

        case "NNW":
        case "N":
            return t("compass.north");

        default:
            console.error(direction);
    }
}
